// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-62dae2ba]{padding:20px 50px}[data-v-62dae2ba] .el-form--inline .el-form-item{width:100%!important}[data-v-62dae2ba] .el-form-item__content{width:85%!important}.mt50[data-v-62dae2ba]{margin-bottom:50px}", ""]);
// Exports
module.exports = exports;
